import React from "react";
import { formatPrice } from "shared/AppFunctions/formatPrice";

export interface PriceSimulatorProps {
    basePrice: number;
    label?: string;
}

const PriceSimulator: React.FC<PriceSimulatorProps> = ({
    basePrice,
    label = "Prezzo finale in vetrina"
}) => {
    const finalPrice = formatPrice(basePrice || 0, true);

    return (
        <div className="bg-neutral-100 dark:bg-neutral-800 p-3 rounded-md min-w-[180px]">
            <div className="text-xs text-neutral-500 dark:text-neutral-400 mb-1">
                {label}
            </div>
            <div className="text-lg font-semibold text-secondary-700 dark:text-secondary-500">
                {finalPrice}
            </div>
            <div className="text-xs text-neutral-400 dark:text-neutral-500 mt-1">
                (incl. commissioni + IVA)
            </div>
        </div>
    );
};

export default PriceSimulator;
